import { render, staticRenderFns } from "./ModalBanner.vue?vue&type=template&id=6b217db8&"
import script from "./ModalBanner.vue?vue&type=script&lang=js&"
export * from "./ModalBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports